<template>
  <v-container
    fluid
    class="loading-container crud-form-page crud-form-page--edit"
    :class="{ 'min-vh-100': loading }"
  >
    <slot name="modals"> </slot>
    <ErrorAlert :errors="erros"></ErrorAlert>
    <div v-if="loading" class="loading-overlay" role="status">
      <div class="loading-card">
        <span class="spinner"></span>
        <span class="label">{{ $t("Carregando") }}</span>
      </div>
    </div>
    <div v-if="!loading" class="crud-form-shell">
      <v-card class="card-shadow border-radius-xl crud-form-card">
        <div class="card-header-padding pb-0 crud-form-topbar">
          <div class="d-flex justify-end crud-form-topbar__actions">
            <v-tooltip v-if="keyboardShortcutsEnabled" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  class="mr-2"
                  :aria-label="$t('Atalhos_de_teclado')"
                  aria-keyshortcuts="Control+/ Meta+/"
                  @click="openKeyboardShortcuts"
                >
                  <v-icon>mdi-keyboard-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Atalhos_de_teclado") }} (Ctrl/⌘ + /)</span>
            </v-tooltip>
            <v-btn
              id="voltar-topo"
              outlined
              color="primary"
              class="text-none font-weight-bold"
              :loading="loading"
              @click="closeModal"
            >
              <v-icon left>mdi-arrow-left</v-icon>
              {{ $t("Voltar") }}
            </v-btn>
          </div>
        </div>

        <div class="card-header-padding card-border-bottom crud-form-heading">
          <div class="crud-form-heading__icon" aria-hidden="true">
            <v-icon color="#5e72e4" size="21"> mdi-file-edit-outline </v-icon>
          </div>
          <div class="crud-form-heading__content">
            <span class="crud-form-heading__kicker">
              {{ $t("Editar") }}
            </span>
            <span
              class="
                font-weight-600
                text-h3 text-typo
                mb-0
                crud-form-heading__title
              "
            >
              {{
                titulo
                  ? translateLabel(titulo)
                  : $t("editar." + this.nomeSingular.toLowerCase())
              }}
            </span>
          </div>
        </div>

        <v-row justify="center" class="crud-form-body">
          <v-col cols="12" md="12" class="crud-form-body__column">
            <v-form
              ref="formularioCrud"
              :autocomplete="formAutocomplete"
              @submit.prevent="submitForm"
              v-if="!submited"
            >
              <v-container class="crud-form-content">
                <v-row class="crud-form-grid">
                  <slot v-if="contentReady"> </slot>

                  <v-col v-else cols="12">
                    <div class="crud-content-loading" role="status">
                      <div class="loading-card">
                        <span class="spinner"></span>
                        <span class="label">{{ $t("Carregando") }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
              <v-card-actions class="crud-form-actions">
                <v-btn
                  id="salvar"
                  style="z-index: 2"
                  @click="closeModal"
                  :loading="loading"
                  class="
                    ma-1
                    font-weight-bold
                    text-capitalize
                    btn-ls btn-secondary
                    bg-gradient-light
                    px-6
                  "
                  height="39"
                >
                  <v-icon left>mdi-arrow-left</v-icon>
                  {{ $t("Voltar") }}
                </v-btn>
                <v-btn
                  ref="botaoSalvar"
                  id="salvar"
                  style="z-index: 2"
                  type="submit"
                  aria-keyshortcuts="Control+S Meta+S Control+Enter Meta+Enter"
                  :loading="loading"
                  :disabled="!contentReady"
                  class="
                    ma-1
                    font-weight-bold
                    text-none
                    btn-primary
                    bg-gradient-primary
                    px-6
                    ms-3
                  "
                  height="39"
                  v-if="
                    this.nomeSingular !== 'ProdutoCentroEstoque' &&
                    !disableSubmit
                  "
                >
                  <v-icon left>mdi-content-save-outline</v-icon>
                  {{ $t("Enviar") }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <CrudKeyboardShortcutsDialog
      v-model="keyboardShortcutsDialog"
      :shortcuts="crudFormKeyboardShortcuts"
    />
  </v-container>
</template>

<script>
import CrudKeyboardShortcutsDialog from "@/components/base/Crud/CrudKeyboardShortcutsDialog.vue";
import crudFormKeyboardShortcuts from "@/mixins/crudFormKeyboardShortcuts";
import { translateIfMessageExists } from "@/utils/i18n";

export default {
  name: "EditarBase",
  components: { CrudKeyboardShortcutsDialog },
  mixins: [crudFormKeyboardShortcuts],
  inject: {
    closeCrudDialog: {
      default: null,
    },
  },
  props: {
    nomePlural: { type: String, required: true },
    nomeSingular: { type: String, required: true },
    titulo: { type: String, required: false, default: "" },
    submitPersonalizado: { type: Boolean, required: false, default: false }, //Se true usa o método submitForm do parent
    disableSubmit: { type: Boolean, required: false, default: false },
    formAutocomplete: { type: String, required: false, default: "on" },
    itemAtual: { type: Object, required: false, default: null },
    recursoInicial: { type: Object, required: false, default: null },
    recurso: { type: Object, required: false, default: null },
    camposObrigatorios: {
      type: Array,
      default: () => [],
    },
    closeWithCrudDialog: {
      type: Boolean,
      default: false,
    },
    deferContentMount: {
      type: Boolean,
      default: false,
    },
    keyboardShortcutsEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      submited: false,
      loading: false,
      erros: [],
      recursoAtual: {},
      contentReady: !this.deferContentMount,
      contentReadyFrame: null,
      contentReadyTimer: null,
      requiredVisualStateFrame: null,
    };
  },
  created() {
    this.unwatchExternalRecurso = this.$watch(
      () => this.getExternalRecurso(),
      (value) => {
        this.syncExternalRecurso(value);
      },
      { immediate: true }
    );
    this.getRecurso();
  },
  beforeDestroy() {
    this.cancelContentReadySchedule();
    this.cancelRequiredVisualStateSchedule();
    if (this.unwatchExternalRecurso) {
      this.unwatchExternalRecurso();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.syncExternalRecurso(this.getExternalRecurso());
      this.scheduleContentReady();
    });
  },
  watch: {
    itemAtual: {
      handler(newValue) {
        this.syncExternalRecurso(newValue);
      },
      immediate: true,
    },
    recursoInicial: {
      handler(newValue) {
        this.syncExternalRecurso(newValue);
      },
      immediate: true,
    },
    recurso: {
      handler(newValue) {
        this.syncExternalRecurso(newValue);
      },
      immediate: true,
    },
  },
  methods: {
    syncExternalRecurso(value) {
      if (
        !value ||
        typeof value !== "object" ||
        Object.keys(value).length === 0
      ) {
        return false;
      }

      this.recursoAtual = { ...value };
      this.$emit("recurso", this.recursoAtual);
      return true;
    },
    getExternalRecurso() {
      const parentProps = (this.$parent && this.$parent.$props) || {};
      const parentAttrs = (this.$parent && this.$parent.$attrs) || {};

      return [
        this.itemAtual,
        this.recursoInicial,
        this.recurso,
        parentProps.itemAtual,
        parentProps.recursoInicial,
        parentProps.recurso,
        parentAttrs.itemAtual,
        parentAttrs.recursoInicial,
        parentAttrs.recurso,
      ].find(
        (value) =>
          value && typeof value === "object" && Object.keys(value).length > 0
      );
    },
    hasExternalRecurso() {
      return !!this.getExternalRecurso();
    },
    escapeHtml(value) {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
    isEmptyValue(value) {
      if (value === null || value === undefined) {
        return true;
      }
      if (typeof value === "string") {
        return value.trim() === "";
      }
      if (Array.isArray(value)) {
        return (
          value.length === 0 || value.every((item) => this.isEmptyValue(item))
        );
      }
      if (value && value.constructor === Object) {
        return Object.keys(value).length === 0;
      }
      return false;
    },
    normalizeFieldKey(value) {
      return String(value || "")
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]/g, "");
    },
    translateLabel(value) {
      return translateIfMessageExists(this.$i18n, value);
    },
    getConfiguredRequiredFields() {
      return (this.camposObrigatorios || [])
        .map((field) => {
          const config =
            field && typeof field === "object"
              ? field
              : { campo: field, label: field };
          const raw =
            config.campo ||
            config.field ||
            config.name ||
            config.label ||
            config.titulo;
          const enabled =
            config.obrigatorio !== false && config.required !== false;
          if (!raw || !enabled) {
            return null;
          }
          const hasValue =
            Object.prototype.hasOwnProperty.call(config, "valor") ||
            Object.prototype.hasOwnProperty.call(config, "value");
          const keys = [raw, this.translateLabel(raw)].map(
            this.normalizeFieldKey
          );
          return {
            ...config,
            raw,
            label: config.label || raw,
            hasValue,
            value: Object.prototype.hasOwnProperty.call(config, "valor")
              ? config.valor
              : config.value,
            keys: [...new Set(keys.filter(Boolean))],
          };
        })
        .filter(Boolean);
    },
    getComponentFieldKeys(component) {
      if (!component) {
        return [];
      }
      const props = component.$props || {};
      const attrs = component.$attrs || {};
      const propsData =
        (component.$options && component.$options.propsData) || {};
      const vnodeAttrs =
        (component.$vnode &&
          component.$vnode.data &&
          component.$vnode.data.attrs) ||
        {};
      const values = [
        props.name,
        props.label,
        props.titulo,
        props.fieldName,
        propsData.name,
        propsData.label,
        propsData.titulo,
        propsData.fieldName,
        attrs.name,
        attrs.label,
        attrs.titulo,
        attrs.fieldName,
        attrs["field-name"],
        vnodeAttrs.name,
        vnodeAttrs.label,
        vnodeAttrs.titulo,
        vnodeAttrs.fieldName,
        vnodeAttrs["field-name"],
      ];
      return [
        ...new Set(
          values
            .filter((value) => value !== null && value !== undefined)
            .flatMap((value) => [value, this.translateLabel(value)])
            .map(this.normalizeFieldKey)
            .filter(Boolean)
        ),
      ];
    },
    isComponentRequiredByConfig(component) {
      const componentKeys = this.getComponentFieldKeys(component);
      if (componentKeys.length === 0) {
        return false;
      }
      return this.getConfiguredRequiredFields().some((field) =>
        field.keys.some((key) => componentKeys.includes(key))
      );
    },
    isRequiredComponent(component) {
      if (!component) {
        return false;
      }
      const propsData =
        (component.$options && component.$options.propsData) || {};
      if (Object.prototype.hasOwnProperty.call(propsData, "obrigatorio")) {
        return (
          propsData.obrigatorio !== false && propsData.obrigatorio !== "false"
        );
      }
      const attrs = component.$attrs || {};
      if (Object.prototype.hasOwnProperty.call(attrs, "obrigatorio")) {
        return attrs.obrigatorio !== false && attrs.obrigatorio !== "false";
      }
      if (this.isComponentRequiredByConfig(component)) {
        return true;
      }
      const propValue = component.$props && component.$props.obrigatorio;
      return propValue === true;
    },
    getComponentLabel(component) {
      const propLabel = component.$props && component.$props.label;
      const attrLabel = component.$attrs && component.$attrs.label;
      const propName = component.$props && component.$props.name;
      const attrName = component.$attrs && component.$attrs.name;
      const propTitulo = component.$props && component.$props.titulo;
      const attrTitulo = component.$attrs && component.$attrs.titulo;
      const rawLabel =
        propLabel ||
        attrLabel ||
        propTitulo ||
        attrTitulo ||
        propName ||
        attrName;
      if (typeof rawLabel === "string" && rawLabel.trim()) {
        return this.translateLabel(rawLabel);
      }
      const el = component.$el;
      if (el && el.querySelector) {
        const labelEl = el.querySelector(".v-label, label");
        if (labelEl && labelEl.textContent) {
          return labelEl.textContent.trim();
        }
      }
      return this.$t("Campo");
    },
    getComponentValue(component) {
      if (component.$props && component.$props.value !== undefined) {
        return component.$props.value;
      }
      if (component.value !== undefined) {
        return component.value;
      }
      if (component.$data && component.$data.value !== undefined) {
        return component.$data.value;
      }
      if (component.recurso !== undefined) {
        return component.recurso;
      }
      if (component.lazyValue !== undefined) {
        return component.lazyValue;
      }
      if (component.internalValue !== undefined) {
        return component.internalValue;
      }
      if (component.$attrs && component.$attrs.value !== undefined) {
        return component.$attrs.value;
      }
      const el = component.$el;
      if (el && el.querySelector) {
        const input = el.querySelector("input, textarea, select");
        if (input) {
          return input.value;
        }
      }
      return undefined;
    },
    getRequiredComponents() {
      const requiredComponents = [];
      const visited = new Set();
      const walk = (component, ancestorRequired) => {
        if (!component || visited.has(component)) {
          return;
        }
        visited.add(component);
        const isRequired = this.isRequiredComponent(component);
        if (isRequired && !ancestorRequired) {
          requiredComponents.push(component);
        }
        const nextAncestorRequired = ancestorRequired || isRequired;
        const children = component.$children || [];
        children.forEach((child) => walk(child, nextAncestorRequired));
      };
      (this.$children || []).forEach((child) => walk(child, false));
      return requiredComponents;
    },
    removeRequiredVisualState() {
      if (!this.$el || !this.$el.querySelectorAll) {
        return;
      }
      this.$el.querySelectorAll(".campo-obrigatorio-label").forEach((label) => {
        label.classList.remove("campo-obrigatorio-label");
      });
      this.$el
        .querySelectorAll(".campo-obrigatorio-container")
        .forEach((container) => {
          container.classList.remove("campo-obrigatorio-container");
        });
    },
    cancelContentReadySchedule() {
      if (this.contentReadyFrame !== null) {
        if (
          typeof window !== "undefined" &&
          typeof window.cancelAnimationFrame === "function"
        ) {
          window.cancelAnimationFrame(this.contentReadyFrame);
        }
        this.contentReadyFrame = null;
      }
      if (this.contentReadyTimer !== null) {
        clearTimeout(this.contentReadyTimer);
        this.contentReadyTimer = null;
      }
    },
    scheduleContentReady() {
      if (this.contentReady) {
        return;
      }
      if (this.contentReadyFrame !== null || this.contentReadyTimer !== null) {
        return;
      }

      const showContent = () => {
        this.contentReadyFrame = null;
        this.contentReadyTimer = null;
        this.contentReady = true;
      };

      this.contentReadyTimer = setTimeout(showContent, 0);
    },
    cancelRequiredVisualStateSchedule() {
      if (this.requiredVisualStateFrame === null) {
        return;
      }
      if (
        typeof window !== "undefined" &&
        typeof window.cancelAnimationFrame === "function"
      ) {
        window.cancelAnimationFrame(this.requiredVisualStateFrame);
      } else {
        clearTimeout(this.requiredVisualStateFrame);
      }
      this.requiredVisualStateFrame = null;
    },
    scheduleRequiredVisualState() {
      if (this.requiredVisualStateFrame !== null) {
        return;
      }

      const apply = () => {
        this.requiredVisualStateFrame = null;
        this.$nextTick(this.applyRequiredVisualState);
      };

      if (
        typeof window !== "undefined" &&
        typeof window.requestAnimationFrame === "function"
      ) {
        this.requiredVisualStateFrame = window.requestAnimationFrame(apply);
        return;
      }

      this.requiredVisualStateFrame = setTimeout(apply, 0);
    },
    applyRequiredVisualState() {
      this.removeRequiredVisualState();
      this.getRequiredComponents().forEach((component) => {
        const el = component && component.$el;
        if (!el || !el.classList) {
          return;
        }
        el.classList.add("campo-obrigatorio-container");
        if (el.querySelectorAll) {
          el.querySelectorAll(".v-label, label").forEach((label) => {
            label.classList.add("campo-obrigatorio-label");
          });
          const input = el.querySelector("input, textarea, select");
          if (input) {
            input.setAttribute("aria-required", "true");
          }
        }
      });
    },
    getRequiredSourceRecurso() {
      const parentRecurso = this.$parent && this.$parent.recurso;
      if (parentRecurso && typeof parentRecurso === "object") {
        return parentRecurso;
      }
      if (this.recursoAtual && typeof this.recursoAtual === "object") {
        return this.recursoAtual;
      }
      return {};
    },
    getValueByPath(source, path) {
      if (!source || !path) {
        return undefined;
      }
      return String(path)
        .split(".")
        .reduce((value, key) => {
          if (value === null || value === undefined) {
            return undefined;
          }
          return value[key];
        }, source);
    },
    getConfiguredRequiredFieldValue(field) {
      if (field.hasValue) {
        return field.value;
      }
      return this.getValueByPath(this.getRequiredSourceRecurso(), field.raw);
    },
    getMissingRequiredFields() {
      return this.getConfiguredRequiredFields()
        .map((field) => {
          if (this.isEmptyValue(this.getConfiguredRequiredFieldValue(field))) {
            return this.translateLabel(field.label);
          }
          return null;
        })
        .filter(Boolean);
    },
    validateRequiredFields() {
      this.cancelRequiredVisualStateSchedule();
      const missing = this.getMissingRequiredFields();
      if (missing.length === 0) {
        return true;
      }
      const items = missing
        .map((label) => `<li>${this.escapeHtml(label)}</li>`)
        .join("");
      this.$swal.fire({
        title: this.$t("Preencha_todos_os_campos_obrigatorios"),
        html: `<ul>${items}</ul>`,
        icon: "error",
      });
      return false;
    },
    getSubmitSuccessPayload(response, fallback) {
      const data = response && response.data;
      return data && typeof data === "object" ? data : fallback;
    },
    submitForm() {
      if (!this.validateRequiredFields()) {
        return;
      }
      this.loading = true;
      console.log("editarBase submitType", this.submitPersonalizado);
      //Usa método do componente pai se prop submitPersonalizado for true
      if (this.submitPersonalizado) {
        this.$parent
          .submitForm()
          .then((response) => {
            this.erros = [];
            this.submited = true;
            this.loading = false;
            this.$emit(
              "submitSuccess",
              this.getSubmitSuccessPayload(response, this.$parent.recurso)
            );

            this.checkPendingTutorialSucess();
          })
          .catch((erros) => {
            this.erros = erros;
            this.loading = false;
            this.$emit("submitError");
          });
      } else {
        const recursoLimpo = this.limpaMascara(this.$parent.recurso);
        this.$parent.DataService.update(recursoLimpo)
          .then((response) => {
            this.erros = [];
            this.submited = true;
            this.loading = false;
            this.$emit(
              "submitSuccess",
              this.getSubmitSuccessPayload(response, recursoLimpo)
            );
            this.checkPendingTutorialSucess();
          })
          .catch((error) => {
            this.loading = false;
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            this.$emit("submitError");
            console.log(
              " error.response.data.erros",
              error.response.data.errors
            );
            this.erros = error.response.data.errors;
          });
      }
    },
    getRecurso() {
      if (this.hasExternalRecurso()) {
        return;
      }

      const id = this.$route && this.$route.params && this.$route.params.id;
      const dataService = this.$parent && this.$parent.DataService;
      if (!dataService || typeof dataService.find !== "function") {
        return;
      }

      const podeBuscarSemId =
        this.nomeSingular === "configuracoes.inquilino" ||
        dataService.find.length === 0;

      if (!id && !podeBuscarSemId) {
        return;
      }

      this.loading = true;
      dataService
        .find(id)
        .then((response) => {
          this.syncExternalRecurso(response.data);
          this.loading = false;
        })
        .catch((error) => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          console.log(error);
          this.loading = false;
          this.erros.push({
            field: "ID",
            message: "Ocorreu um erro, tente novamente!",
          });
        });
    },
    closeModal() {
      this.$emit("closeModalEdit");
      if (
        this.closeWithCrudDialog &&
        typeof this.closeCrudDialog === "function"
      ) {
        this.closeCrudDialog("edit");
      }
    },
  },
};
</script>

<style>
.crud-content-loading {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.campo-obrigatorio-label::after {
  color: #e53935;
  content: " *";
  font-weight: 700;
}
</style>
